import { render } from "./DocumentTextIcon.vue?vue&type=template&id=13b2078f"
const script = {}

import exportComponent from "/codebuild/output/src1758068389/src/frontend-admin-dash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__